import { Directive } from "@angular/core";
import { defaultPopupDialogConfig, PopupDialogConfig } from "../popup.model";
import { PopupService } from "@core";

@Directive()
export abstract class AbstractPopupDialogDirective {
  constructor(protected _popupService: PopupService) {}

  abstract onClose(): void;

  abstract stepsCount: number;
  abstract currentStep: number;

  config = { ...defaultPopupDialogConfig };

  next() {
    const nextStep = this.currentStep + 1;
    if (nextStep <= this.stepsCount) {
      this.currentStep = nextStep;
    } else {
      this._handleClose();
    }
  }

  back() {
    const previousStep = this.currentStep - 1;
    if (previousStep >= 1) {
      this.currentStep = this.currentStep - 1;
    }
  }

  closeModal() {
    this._handleClose();
  }

  private _handleClose() {
    this.onClose();
    this._popupService.closePopup();
  }

  updateConfig(config: Partial<PopupDialogConfig>): void {
    setTimeout(() => {
      const newConfig = { ...defaultPopupDialogConfig, ...config };
      this.config.title = newConfig.title;
      this.config.nextButtonText = newConfig.nextButtonText;
      this.config.backButtonText = newConfig.backButtonText;
      this.config.showNextButton = newConfig.showNextButton;
      this.config.showBackButton = newConfig.showBackButton;
    });
  }
}
